// extracted by mini-css-extract-plugin
module.exports = {"section_wrapper":"SectionWrapper_section_wrapper__GrzUP","column_on_break":"SectionWrapper_column_on_break__1cuE-","bottom_space":"SectionWrapper_bottom_space__1kXQv"};